import api from './client';

/** Phase 54 · Pay-per-minute One-to-One calls — API client. */

export const getCallConfig = async () => (await api.get('/o2o/call-config')).data;

export const getAvailableCreators = async () =>
  (await api.get('/o2o/available-creators')).data;

export const getCreatorCallStatus = async (creatorId) =>
  (await api.get(`/o2o/creators/${creatorId}/call-status`)).data;

export const getCallAvailability = async (creatorIds) =>
  (await api.get('/o2o/availability', { params: { creator_ids: creatorIds.join(',') } })).data;

export const getMyCallSettings = async () => (await api.get('/o2o/me/call-settings')).data;

export const updateMyCallSettings = async (patch) =>
  (await api.put('/o2o/me/call-settings', patch)).data;

export const initiateCall = async (creatorId, mode) =>
  (await api.post('/o2o/calls', { creator_id: creatorId, mode })).data;

export const getCall = async (callId) => (await api.get(`/o2o/calls/${callId}`)).data;

export const getMyRing = async () => (await api.get('/o2o/ring')).data;

export const acceptCall = async (callId) => (await api.post(`/o2o/calls/${callId}/accept`)).data;

export const rejectCall = async (callId) => (await api.post(`/o2o/calls/${callId}/reject`)).data;

export const cancelCall = async (callId) => (await api.post(`/o2o/calls/${callId}/cancel`)).data;

export const endCall = async (callId, reason = null) =>
  (await api.post(`/o2o/calls/${callId}/end`, reason ? { reason } : {})).data;

export const getCallToken = async (callId) => (await api.post(`/o2o/calls/${callId}/token`)).data;

export const getCallsHistory = async (role = 'creator', limit = 30) =>
  (await api.get('/o2o/calls-history', { params: { role, limit } })).data;

export const joinWaitlist = async (creatorId, mode) =>
  (await api.post('/o2o/waitlist', { creator_id: creatorId, mode })).data;

export const leaveWaitlist = async (entryId) =>
  (await api.delete(`/o2o/waitlist/${entryId}`)).data;

export const getMyWaitlist = async () => (await api.get('/o2o/waitlist/mine')).data;

// Admin
export const adminGetCallSettings = async () =>
  (await api.get('/admin/o2o-calls/settings')).data;

export const adminPatchCallSettings = async (patch) =>
  (await api.patch('/admin/o2o-calls/settings', patch)).data;

export const adminGetCallStats = async (days = 30) =>
  (await api.get('/admin/o2o-calls/stats', { params: { days } })).data;

export const adminGetRecentCalls = async (limit = 50) =>
  (await api.get('/admin/o2o-calls/recent', { params: { limit } })).data;
